import React, { HTMLProps, useState } from 'react';
import { tv } from 'tailwind-variants';
import Spinner from './Spinner';
import { isNommi } from '@/utils/brand';

const button = tv({
  base: `
    aling-center
    block
    duration-300
    disabled:opacity-60
    ease-in-out
    font-bold
    rounded-md
    shadow-sm
    text-white
    transition
    w-full
    hover:shadow-button-hover
  `,
  variants: {
    buttonColor: {
      green: 'bg-green-500 hover:bg-green-600',
      indigo: 'bg-indigo-500 hover:bg-indigo-600',
    },
    size: {
      sm: 'px-3 py-2 text-sm',
      md: 'px-4 py-3 text-base',
      lg: 'px-6 py-4 text-lg',
    },
  },
});

type Props = Omit<HTMLProps<HTMLButtonElement>, 'size'> & {
  size?: 'sm' | 'md' | 'lg';
  type?: 'button' | 'submit' | 'reset';
  loading?: boolean;
  backgroundColor?: string;
  textColor?: string;
};

const Button: React.FC<Props> = ({
  loading,
  size = 'md',
  children,
  className,
  backgroundColor,
  textColor,
  type = 'button',
  ...props
}) => {
  const [isHovered, setIsHovered] = useState(false);

  const bgColor = backgroundColor || (isNommi ? '#2886B9' : '#0F7864');
  const hoverColor = isNommi ? '#1f6e94' : '#0b6856';

  return (
    <button
      type={type}
      style={{
        backgroundColor: isHovered ? hoverColor : bgColor,
        color: textColor || '#fff',
      }}
      className={`${button({ size })} ${className ?? ''}`}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      {...props}
    >
      {loading ? <Spinner className="w-4 h-4" /> : children}
    </button>
  );
};

export default Button;
